<div>
	@if (!hideTitle) {
		<h4 class="gen-title section-title">{{ name | langVal }}</h4>
	}

	@for (section of sections; track section.tableName) {
		<div
			class="section-row"
			[style.background-color]="section.color"
			(click)="openSection(section)"
		>
			<button
				class="btn btn-icon"
				titleLang="expand"
				[icon]="section.isOpen ? 'report_expand' : 'report_expand'"
			></button>
			<!-- <h4 class="gen-title">{{ (section.isOpen ? "" : section.title) | langVal }}</h4> -->
			<h4 class="gen-title">{{ section.title | langVal }}</h4>
		</div>
		@if (section.isOpen) {
			<div class="section-contents">
				@if (section.nonTable) {
					@switch (section.tableName) {
						@case ("cc-params-user-details") {
							<app-cc-params-user-details />
						}
						@case ("change_password") {
							<app-change-password />
						}
						@case ("cc-insert-patient-templates") {
							<app-cc-insert-patient-templates />
						}
						@case ("patient-details-fields-manage") {
							<app-patient-details-fields-manage />
						}
						@case ("patient_unification") {
							<app-patient-unify />
						}
						@case ("import-patients") {
							<app-import-patients />
						}
						@case ("import-followups") {
							<app-import-followups />
						}
						@case ("import-tags") {
							<app-import-tags />
						}
						@case ("accountant") {
							<app-cc-params-accountant />
						}
						@case ("credit-clearance") {
							<app-cc-params-credit-clearance />
						}
            @case ("ita-get-auth") {
							<app-ita-get-auth />
						}
						@case ("tests") {
							<app-test-manage />
							<!--            <app-tests-menu />-->
						}
						@case ("public_tests") {
							<app-cc-params-public-tests />
						}
						@case ("holiday") {
							<app-cc-params-holiday />
						}
						@case ("activity") {
							<app-activity />
						}
						@case ("admininvoices") {
							<app-user />
						}
						@case ("payment") {
							<app-payment-form />
						}
						@case ("user-details-website") {
							<app-cc-params-user-details-website />
						}

						@case ("sub-user") {
							<app-cc-params-sub-user />
						}

						@case ("user") {
							<app-user />
						}

						<!-- @case("cc-reports"){
            <app-cc-reports />
          } -->
						<!-- @case("hashav"){
            <app-cc-params-hashav />
          } -->
					}
				} @else {
					@if (section?.isPagi) {
						<app-gen-table-pagination [tableName]="section.tableName" />
					} @else {
						<app-gen-table [tableName]="section.tableName" />
					}
				}
			</div>
		}
		<!-- <hr class="separation-line" /> -->
	}
</div>
